import React from "react";
import strapi from "scripts/strapi/index.js";
import ResourcesLayout from "layouts/resources";


export default function ArticlesPage({articles}) {
  return <ResourcesLayout
    articles={articles}
    title="Resources | Deviate Labs"
    description="The official Deviate Labs' collection of articles with the latest growth hacking news, tips, and tricks."
    headline="Growth Marketing Resources"
    subheadline="The official Deviate Labs' collection of articles with the latest growth hacking news, tips, and tricks."
    canonical="/resources/"
  />;
}


export async function getStaticProps() {
  let data = await strapi.article.findAll({
    filters: {},
    populate: {
      coverArt: "*",
    },
    fields: [ //don't include the body since it's large and unnecessary
      "headline",
      "slug",
      "teaser",
      "priority",
      "category",
      "publishedAt",
    ],
  });

  return {
    props: {
      articles: data,
    },
    revalidate: 60,
  };
}
